import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { Button, Spinner } from 'react-bootstrap';
import './Login.css';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    const result = await login(email, password);

    if (!result.success) {
      toast.error(result.message);
      setIsLoading(false);
    }
  };

  return (
     <div className="login-page-bg">
      <div className="container-fluid d-flex justify-content-center align-items-center vh-100 bg-light login-page-container">
        <div className="card shadow-lg" style={{ width: '25rem' }}>
          <div className="card-body p-5">
            <h3 className="card-title text-center mb-4">AML System Login</h3>
            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label htmlFor="emailInput" className="form-label">Email address</label>
                <input type="email" className="form-control" id="emailInput" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@aml.com" required />
              </div>
              <div className="mb-3">
                <label htmlFor="passwordInput" className="form-label">Password</label>
                <input type="password" className="form-control" id="passwordInput" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="password" required />
              </div>
              <div className="d-grid">
                <Button type="submit" variant="primary" disabled={isLoading}>
                  {isLoading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
                  {isLoading ? ' Logging In...' : 'Login'}
                </Button>
              </div>
              <div className="form-text mt-3 text-center">
                  <p className="mb-1"><strong>Admin:</strong> admin@aml.com</p>
                  <p className="mb-1"><strong>Analyst:</strong> analyst@aml.com</p>
                  <p>(Password for all is: <strong>password</strong>)</p>
              </div>
            </form>
          </div>
        </div>
      </div>
     </div>
  );
};

export default Login;